import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllChangeListUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllChangeList/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllChangeListUser = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllChangeListUser;
};


const setActiveChangeList = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setChangeListActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllChangeListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ChangeList  - ',response);


    return AllChangeListUser;
};



const setDeletedChangeList = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setChangeListDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllChangeListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ChangeList  - ',response);


    return AllChangeListUser;
};




const setUpdateChangeList = async (dataChangeListUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setChangeListUpdate/'),{
        dataChangeListUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllChangeListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ChangeList  - ',response);


    return AllChangeListUser;
};


const setSaveNewChangeList = async (dataChangeListUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewChangeList/'),{
        dataChangeListUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllChangeListUser = data;

    // console.log('Сервер вернул данные по обновлению статуса ChangeList  - ',response);


    return AllChangeListUser;
};

Mock.onGet('/api/reference/getAllChangeList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllChangeListUser = await getAllChangeListUser();

    // if (!AllChangeListUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllChangeListUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllChangeListUser,
    ]


})


Mock.onPost('/api/reference/setActiveChangeList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllChangeListUser = await setActiveChangeList(id,val);

    // if (!AllChangeListUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllChangeListUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllChangeListUser,
    ]


})

Mock.onPost('/api/reference/setDeletedChangeList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllChangeListUser = await setDeletedChangeList(id,val);

    // if (!AllChangeListUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllChangeListUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllChangeListUser,
    ]


})


Mock.onPost('/api/reference/setUpdateChangeList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataChangeListUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const ChangeList = await setUpdateChangeList(dataChangeListUpdate);

    // console.log('Серовер вернул данные ',AllChangeListUser);

    // if (!ChangeList) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!ChangeList) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        ChangeList,
    ]


})


Mock.onPost('/api/reference/setSaveNewChangeList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataChangeListUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const ChangeList = await setSaveNewChangeList(dataChangeListUpdate);

    // console.log('Серовер вернул данные ',AllChangeListUser);

    // if (!ChangeList) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!ChangeList) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        ChangeList,
    ]
})